import { authApi } from "./AuthApi";
import { addressApi } from "./AddressApi";
import { virtualLockerApi } from "./VirtualLockerApi";
import { orderApi } from "./OrderApi";
import { settingApi } from "./SettingApi";
import { customerApi } from "./admin/customer-api";
import { adminApi } from "./admin/admin-api";
import { shopperApi } from "./admin/shopper-api";
import { personalShopperApi } from "./PersonalShopperApi";
import { groupCartApi } from "./group-cart-api";
export const API = {
  ...authApi,
  ...addressApi,
  ...virtualLockerApi,
  ...customerApi,
  ...adminApi,
  ...shopperApi,
  ...orderApi,
  ...settingApi,
  ...personalShopperApi,
  ...groupCartApi,
};
